export const MAIN_CONTENTS = ['samudkoy', 'overview'] as const

/** SAMUDKOY Constants */
export const SAMUDKOY = {
  MENUS: ['menu1', 'menu2', 'menu3', 'menu4'],
  NUM_PAGES: 69,
  TRANSLATE_TH_PAGES: <number[]>[
    5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64,
    65, 66, 67,
  ],
  TRANSLATE_EN_PAGES: <number[]>[
    5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64,
    65, 66, 67,
  ],
} as const

/** OVERVIEW Constants */
export const OVERVIEW = {
  MENUS: ['menu1', 'menu2', 'menu3', 'menu4'],
  NUM_PAGES: 69,
} as const
